"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQG_ON_SITE_CAP_KG = exports.VSQG_ON_SITE_ACUTE_CAP_KG = exports.VSQG_ON_SITE_CAP_KG = exports.TEXAS_CLASS_1_ONLY_LB = exports.KSQG_THRESHOLD_HAZARDOUS_LB = exports.LQG_THRESHOLD_HAZARDOUS_LB = exports.LQG_THRESHOLD_HAZARDOUS_KG = exports.SQG_THRESHOLD_HAZARDOUS_LB = exports.SQG_THRESHOLD_HAZARDOUS_KG = exports.VSQG_THRESHOLD_HAZARDOUS_LB = exports.VSQG_THRESHOLD_HAZARDOUS_KG = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = void 0;
// Federal Generator Status Thresholds
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = 1;
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = 2.2;
exports.VSQG_THRESHOLD_HAZARDOUS_KG = 0;
exports.VSQG_THRESHOLD_HAZARDOUS_LB = 0;
exports.SQG_THRESHOLD_HAZARDOUS_KG = 100;
exports.SQG_THRESHOLD_HAZARDOUS_LB = 220;
exports.LQG_THRESHOLD_HAZARDOUS_KG = 1000;
exports.LQG_THRESHOLD_HAZARDOUS_LB = 2200;
// Kansas Small Quantity Generator
exports.KSQG_THRESHOLD_HAZARDOUS_LB = 55;
// Texas Class 1 Only Threshold
exports.TEXAS_CLASS_1_ONLY_LB = 220;
// Federal on-site accumulation caps (40 CFR 262.14/262.16) — the maximum
// hazardous waste a generator may hold on site at any time, distinct from the
// monthly generation-rate thresholds above. LQGs have no federal quantity cap
// (their accumulation is time-limited instead).
exports.VSQG_ON_SITE_CAP_KG = 1000;
exports.VSQG_ON_SITE_ACUTE_CAP_KG = 1;
exports.SQG_ON_SITE_CAP_KG = 6000;
//# sourceMappingURL=wasteGeneratorStatusThresholds.js.map